import { CashCount, CoinDenomination, NoteDenomination } from './cash-count';
import { CurrencyDenominationsDto } from '../currency-denominations';
import { BankingCashCountDto } from './banking-cash-count.dto';

export class BaseCashCount {

  static generateCashCountObject(
    data: any, /*BankingCashCountDto[] | BankingSafeCountDetailDto[],*/
    currencyDenominations: CurrencyDenominationsDto[]
  ): CashCount {
    const noteDenominations: NoteDenomination[] = [];
    const coinDenominations: CoinDenomination[] = [];
    if (currencyDenominations) {
      currencyDenominations.forEach(den => {
        const savedValue = data.find(saved => saved.value === den.value);
        if (!den.isCoin) {
          noteDenominations.push(
            new NoteDenomination(den.value,
              savedValue?.quantity || 0
            ));
        } else {
          coinDenominations.push(new CoinDenomination(
            den.value,
            savedValue?.quantity || 0,
            den.bagQuantity,
            savedValue?.bags || 0
          ));
        }
      });
    }
    return new CashCount(noteDenominations, coinDenominations);
  }

  static calculateCardRecon(data: BankingCashCountDto[]): { total: number } {
    if (data.length === 0) {
      return {total: 0};
    }
    let value = 0;
    data.forEach(cardCount => {
      value += cardCount.value;
    });
    return {total: value};
  }
}
